<template>
  <form @submit.prevent="zoneAction">
    <div class="mb-3">
      <label>Name</label>
      <input
          v-model="zone.name"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.zone.name.$error,
          }"
      />
      <p
          v-for="error of v$.zone.name.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Divider Road</label>
      <input
          v-model="zone.divider"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.zone.divider.$error,
          }"
      />
      <p
          v-for="error of v$.zone.divider.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Location Name</label>
      <input
          v-model="zone.location"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.zone.location.$error,
          }"
      />
      <p
          v-for="error of v$.zone.location.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Description</label>
      <textarea
          v-model="zone.details"
          class="form-control"
          :class="{
            'is-invalid': v$.zone.details.$error,
          }"
          rows="5"
      ></textarea>
      <p
          v-for="error of v$.zone.details.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in SettingsErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-3 h3" disabled v-if="SettingsLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapGetters} from "vuex";

export default {
name: "delivery-zone-form",
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      zone: this.selected_zone,
    }
  },
  props: {
    selected_zone: {
      type: Object,
      default () {
        return {
          name: '',
          divider: '',
          location: '',
          details: ''
        }
      }
    },
    button_text: {type: String}
  },
  computed: {
    ... mapGetters({
      SettingsLoading: 'settings/settingsLoading',
      SettingsErrors: 'settings/settingsErrors'
    }),
  },
  validations () {
    return {
      zone: {
        name: {required},
        divider: {required},
        location: {required},
        details: {required}
      }
    }
  },
  methods: {
    async zoneAction(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      this.$emit('zoneAction', this.zone)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
